<template>
  <div no-body class="lku-koran-kiriman">
              <b-input-group>
                <b-input-group-prepend> <span class="pt-1 pr-1" size="sm">Agen</span></b-input-group-prepend>
                <b-form-input
                  v-model="tblData.CustCode"
                  @keyup.13.native="refresh()"
                  size="sm"
                  placeholder="Code "
                ></b-form-input>
                <b-form-input
                  v-model="tblData.CustName"
                  @keyup.13.native="refresh()"
                  size="sm" 
                  placeholder="Name "
                ></b-form-input>
                <b-form-checkbox v-model="tblData.inclsubagen" value=1 unchecked-value=0 class="pt-2">incl.sub</b-form-checkbox>
                <b-input-group-append> <span class="ml-3 pt-1 pr-1">Tgl.Edisi</span></b-input-group-append>
                <b-form-input v-model="tblData.tgl1" type="date" class="mr-1" size="sm" ></b-form-input>
                <b-input-group-append> <span class="pt-1 pr-1">-</span></b-input-group-append>
                <b-form-input v-model="tblData.tgl2" type="date" class="mr-1" size="sm" ></b-form-input>
                  <!-- <b-form-input
                    v-model="tblData.nofaktur"
                    @keyup.13.native="refresh()"
                    size="sm"
                    placeholder="No. Faktur"
                  ></b-form-input> -->
                <b-input-group-append>
                  <b-button class="btn btn-success ml-1" @click="search()" size="sm">
                    <i class="fa fa-refresh"></i> Apply
                  </b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button class="btn btn-secondary ml-1"  @click="clearFilter()" size="sm">
                    <i class="fa fa-eraser"></i> Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
    <b-table
      class="mb-0"
      ref="tblKoranCust"
      responsive
      striped
      hover
      small
      style="font-size:smaller;"
      :items="data"
      :fields="fields"
      :current-page="tblData.page"
      :per-page="tblData.limit"
      :sort-by.sync="tblData.sortBy"
      :sort-desc.sync="tblData.sortDesc"
      :key="tblData.limit"
      @row-clicked="selectItem"
    >
        <template v-slot:cell(tanggal)="data">
            {{data.item.tanggal | ambilNamaHari}}, {{ data.item.tanggal | moment("DD MMM YYYY") }} 
        </template>
    </b-table>
    <b-row>
      <b-col cols="6">
        <div>
          Showing
          {{(tblData.page - 1) * tblData.limit + 1}}
          to
          {{tblData.page * tblData.limit}}
          of
          {{tblData.total}}
          entries
        </div>
      </b-col>
      <b-col cols="6">
        <b-pagination
          align="right"
          :total-rows="tblData.total"
          :per-page="tblData.limit"
          v-model="tblData.page"
        ></b-pagination>
      </b-col>
    </b-row>
    <loading :active.sync="isLoading" :height="100" :width="100" color="#4b8cf4" ></loading>       

  </div>
</template>
<style lang="scss">
.lku-adv {
  td {
    padding: 0;

    a {
      //   border: 1px solid;
      text-decoration: none;
      display: block;
      padding: 0.5rem 0.75rem;
    }
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import 'vue-loading-overlay/dist/vue-loading.css';
import koran_kiriman from "../../apis/koran_kirim_pesanan";
import moment from 'moment';

export default {
  components: { Loading },
  data() {
    return {
      isLoading: false,
      pertamakali:true,
      items: [],
      customer_group:[{ value: '', text: "-- Semua Jenis --" }],
      fields: [
        {
          key: "tanggal",
          label: "Tgl.Kirim",
          sortable: true
        },
        {
          key: "CustCode",
          label: "Kode Agen",
          sortable: true
        },
        {
          key: "CustName",
          label: "Nama Agen",
          sortable: true
        },
        {
          key: "kota_name",
          label: "kota",
          sortable: true
        },
        {
          key: "kiriman_name",
          label: "Jenis Kiriman",
          sortable: true
        },
        {
          key: "langganan",
          label: "Bayar NonRetur",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center"
        },       
        {
          key: "konsi",
          label: "Bayar NonRetur",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center"
        },       
        {
          key: "totpaid",
          label: "Total BerBayar",
          variant: "primary",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },       
        {
          key: "gratis",
          label: "Tdk.Bayar",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
        {
          key: "totkirim",
          label: "Total",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-center"
        }
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: 'tanggal',
        sortDesc: true,
        inclsubagen:1,
        tgl1:'', tgl2:''
      },
    };
  },
  props: ["tgl1"],
  created:  function() {
  //   const a = crud.list({ tablename: "koranjeniskiriman", limit: 1000 }).then((a) => {
  //       this.customer_group = a.reduce((newArr, el, idx) => {
  //         newArr.push({ value: el.kiriman_code, text: el.kiriman_name });
  //         return newArr;
  //       }, [{ value: '', text: "-- Semua Jenis --" }]);
  //   }); 

    if (this.tgl1) {
      this.tblData.tgl1= this.tgl1;
    }

  },
  filters: {
    ambilNamaHari(tanggal) {
      const namesDay = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
      ];
      const day_ = namesDay[moment(tanggal).day()];
      return day_;
    }
  },  

  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function() {
        if (this.pertamakali==true){
          setTimeout(() => {
              this.pertamakali=false;
          }, 500);
        } else {
          this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
          let tgl1isi=false;
          if (this.tblData.tgl1) {
            this.tblData.tgl2= this.tblData.tgl1; 
            tgl1isi = true;
          } else {
                this.tblData.tgl1='';          
                this.tblData.tgl2='';          
            // if (this.tgl1) {
            //   this.tblData.tgl1= this.tgl1;
            //   // console.log('this.tgl1: ',this.tgl1);
            // }
          }
          try {
            this.isLoading=true;
            const list = await koran_kiriman.list(this.tblData);
            this.isLoading=false;

            if (tgl1isi==false) {
              setTimeout(() => {
                this.tblData.tgl1='';          
                this.tblData.tgl2='';          
              }, 500);
            }
            return list;
          } catch (error) {
                this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
          }
        }
    },

    selectItem(item, index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
      this.tblData.nofaktur = "";
      this.tblData.CustCode = "";
      this.tblData.CustName = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.salesae_name = "";
      // this.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    }, 
    refresh: async function() {
      this.$refs.tblKoranCust.refresh();
    }
  }
};
</script>
